<div class="container-fluid">
    <div class="row">
        <div class="col-4">
            <ul class="nav justify-content-start nav-tabs-horizontal flex-nowrap" role="tablist">
                <li class="nav-item nav-tab" role="presentation">
                    <a class="nav-link text-nowrap" routerLinkActive="active-link" role="tab"
                       [routerLink]="['audit-logs']" [routerLinkActiveOptions]="{ exact: true }"
                       [attr.aria-selected]="isActive('audit-logs')">
                        Audit Event Logs
                    </a>
                </li>
                <li class="nav-item nav-tab" role="presentation">
                    <a class="nav-link text-nowrap" routerLinkActive="active-link" role="tab"
                       [routerLink]="['audit-reports']" [routerLinkActiveOptions]="{ exact: true }"
                       [attr.aria-selected]="isActive('audit-reports')">
                        Audit Reports
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>

